import Hourglass from '../../src/legacy/Hourglass.tsx';
export default Hourglass;
